<template>
  <div>
    <a-form-model :model="countData" :rules="rules" ref="ruleForm">
      <div id="myCal">
        <!-- 保费试算 -->
        <div class="title_">
          <div class="cutleft_ order">保费试算</div>
          <div class="cutleft_ policy">险种信息</div>
          <div class="cutoff_"></div>
        </div>
        <a-row class="changeStyle_">
          <a-col :span="19">
            <div class="form_item" style="justify-content: flex-start">
              <label>保险期间</label>
              <div class="pre-box" style="margin-left: 10px">
                <div class="">
                  <a-radio-group :disabled="disabledAll" v-model="guapre" @change="e => changeData(e.target.value, 'BZQJa')">
                    <a-radio v-for="item in guarantPre" :key="item.key" :value="item.key">{{ item.value }}</a-radio>
                  </a-radio-group>
                </div>
              </div>
            </div>
            <div class="order">
              <a @click="$tools.downloadFile(fileCodeContent.occ_url)">职业类别表</a>
            </div>
            <div class="form_item order">
              <label>投保职业</label>
              <div class="right_">
                <div class="check_item s_input" v-for="item in occupationNumberList" :key="item.occupationKind">
                  <label for>
                    {{ item.occupationKind + '类' }}
                  </label>
                  <a-input-number :min="0" :disabled="disabledAll" v-model="item.personNum" @blur="value => changeData(value, 'TBZYa')"></a-input-number>
                  <span>人</span>
                </div>
                <div class="check_item">
                  <span>总人数：{{ totalNumber.allNumber }}人</span>
                </div>
              </div>
            </div>
          </a-col>
          <a-col :offset="2" :span="4" class="calRight_ order">
            <div class="calTxt_">保费合计</div>
            <div class="calmoney_">¥ {{ premiumSum }}</div>
          </a-col>
        </a-row>
      </div>
      <div class="risk_">
        <p class="p-header">必选方案</p>
        <div class="form_item">
          <a-row :gutter="24">
            <a-form-model-item :label-col="{ span: 15 }" label="保障方案选择" class="zuxianclass" prop="planSelect">
              <div class="right_" style="width: 300px">
                <a-select :disabled="disabledAll" placeholder="请选择" class="select_" @change="value => changePlanData(value)" v-model="countData.planSelect">
                  <a-select-option v-for="item in BZFAXXOptions" :key="item.value" :value="item.value">{{ item.name }}</a-select-option>
                </a-select>
              </div>
            </a-form-model-item>
          </a-row>
        </div>
        <div>
          <div class="form_item">
            <label class="item-label">意外身故及伤残保障</label>
            <div class="right_" style="margin-top: 4px">
              <a-input :disabled="true" style="width: 300px" :value="countData.YWSGSC | million" placeholder="请直接选择保障方案"></a-input>
            </div>
          </div>
          <div class="form_item">
            <label class="item-label">意外医药补偿</label>
            <div class="right_" style="margin-top: 10px">
              <a-input :disabled="true" style="width: 300px" :value="countData.YWYYBT | million" placeholder="请直接选择保障方案"></a-input>
            </div>
          </div>
          <div class="form_item">
            <label class="item-label">意外每日住院津贴</label>
            <div class="right_">
              <a-select :disabled="true" placeholder="请直接选择保障方案" style="width: 300px" class="select_" v-model="countData.YWMRJT">
                <a-select-option v-for="(item, index) in YWZYJTOptions" :key="item.value + 'YWMRJT' + index" :value="item.value">{{ item.name }}</a-select-option>
              </a-select>
            </div>
          </div>
        </div>
        <p class="p-header">可附加方案</p>
        <div>
          <div class="form_item">
            <label>社保外用药</label>
            <div class="right_">
              <a-select :disabled="disabledAll || !countData.planSelect" placeholder="请选择" style="width: 300px" class="select_" v-model="countData.SBWYY" @change="value => changeData(value, 'SBWYY')">
                <a-select-option v-for="(item, index) in KZSCOptions" :key="item.value + 'SBWYY' + index" :value="item.value" :disabled="item.disabled">{{ item.name }}</a-select-option>
              </a-select>
            </div>
          </div>
        </div>
        <div class="btn_list">
          <a-button style="margin-bottom: 50px" class="calBtn_" type="primary" @click="goplicy" v-if="!agreementRead"> 完成报价，立即投保</a-button>
          <a-button class="calBtn_" :disabled="disabledAll" type="primary" @click="countPremiumSum()">刷新试算</a-button>
        </div>
      </div>
    </a-form-model>
  </div>
</template>

<script>
let DATA = require('../data').default;
import { riskinfoMixin } from '@/mixins/riskinfoMixin.js';
export default {
  mixins: [riskinfoMixin],
  data() {
    return {
      // 表单校验项
      rules: {
        planSelect: [{ required: true, message: '请选择', trigger: 'change' }]
      },
      productCode: '', // 产品code
      plan: '', // 计划code
      guapre: '1', // 保险期间
      guarantPre: DATA.guarantPre,//保险期间码表
      premiumSum: 0, //总保费
      // 保障方案选择
      // 扩展残疾鉴定国家工伤标准
      KZSCOptions: DATA.KZSCOptions, // 附加、不附加码表
      YWZYJTOptions: DATA.YWZYJTOptions, // 意外每日住院津贴码表
      // 测算要提交的数据
      countData: {
        BZQJa: 1, //保障期间?
        planSelect: undefined, //保障方案选择
        YWSGSC: 0, //意外身故及伤残保障
        YWYYBT: 0, //意外医药补贴
        YWMRJT: 0, //意外每日住院津贴
        SBWYY: -1 //社保外用药
      },
      //提交data
      data: {
        riskInfos: [],
        salPolicy: {
          productCode: '', //产品code
          bracket: '1', //保费期限
          planCode: ''
        },
        salPolicyExt: {
          isworkheightinvolved: 2
        },
        salPolicyHolder: {
          addfifty: '1', // 测算类型
          stature: 2 //是否高空（2-否，1-是）
        },
        premiumBaseDtoList: [] //人数
      },
      // 投保职业
      occupationNumberList: [
        {
          occupationKind: '1',
          personNum: 0
        },
        {
          occupationKind: '2',
          personNum: 0
        },
        {
          occupationKind: '3',
          personNum: 0
        },
        {
          occupationKind: '4',
          personNum: 0
        },
        {
          occupationKind: '5',
          personNum: 0
        },
        {
          occupationKind: '6',
          personNum: 0
        }
      ]
    };
  },
  filters: {
    million: value => {
      let num;
      if (value > 9999) {
        num = Math.floor(value / 1000) / 10 + '万';
      } else if (value < 9999 && value > -9999) {
        num = value;
      } else if (value < -9999) {
        //小于-9999显示-x.xx万
        num = -(Math.floor(Math.abs(value) / 1000) / 10) + '万';
      }
      return num;
    }
  },
  computed: {
    BZFAXXOptions() {
      let plansValues = DATA.plansValues;
      let occupationNumberList = this.occupationNumberList;
      if (occupationNumberList[5].personNum > 0 || occupationNumberList[4].personNum > 0) {
        if (this.countData.planSelect == 'XSAIGHSB2022C09' || this.countData.planSelect == 'XSAIGHSB2022C10') {
          this.countData.planSelect = 'XSAIGHSB2022C01';
          this.changePlanData('XSAIGHSB2022C01');
        }
        plansValues = plansValues.filter(item => item.value != 'XSAIGHSB2022C09' && item.value != 'XSAIGHSB2022C10');
      }
      return plansValues;
    },
    // 选的总投保人数
    totalNumber() {
      let num1_3 = 0,
        num4_6 = 0;
      this.occupationNumberList.slice(0, 3).forEach(e => {
        num1_3 += Number(e.personNum);
      });
      this.occupationNumberList.slice(3).forEach(e => {
        num4_6 += Number(e.personNum);
      });

      return {
        allNumber: parseInt(num1_3 + num4_6),
        num1_3,
        num4_6
      };
    },
    // 险种的数组
    riskInfos() {
      let infos = [
        {
          riskCode: 'XSAIGHSB2022C01', //保障方案选择
          amount: 0,
          dutyCode: 'XSAIGHSB2022C01',
          premiumAmt: 0
        },
        {
          riskCode: 'XSAIGHSB2022CR01', //社保外用药
          amount: this.countData.SBWYY,
          dutyCode: 'XSAIGHSB2022CTZ',
          premiumAmt: 0
        }
      ];
      return infos;
    }
  },
  props: ['disabledAll'],
  created() {
    const { p, planCode } = this.$route.query;
    this.productCode = p;
    this.plan = planCode;
    this.changePlanData(planCode, 'init');
    this.countPremiumSum('init');
  },
  mounted() {
    this.$bus.$on('busRiskInfos', data => {
      let obj = this.$lodash.cloneDeep(this.countData);
      let riskInfos = data.riskInfos;
      this.data.salPolicy = data.salPolicy;
      riskInfos.forEach(e => {
        if (e.dutyCode == 'XSAIGHSB2022CTZ' && e.riskCode == 'XSAIGHSB2022CR01') obj.SBWYY = e.amount;
      });
      // 回显传值的问题
      this.countData = { ...obj };
      this.guapre = data.salPolicy.bracket || '1';
      this.countData.BZQJa = this.guapre;
      this.changeData('init');
    });
  },
  methods: {
    //选择计划
    changePlanData(value, type) {
      if (!value) {
        return;
      }
      this.countData.planSelect = value;
      let options = this.BZFAXXOptions.filter(item => item.value == value)[0].optionSelect;
      this.countData = { ...this.countData, ...options };
      this.plan = value;
      this.$router.push({
        path: location.pathname,
        query: {
          u: this.$route.query.u,
          p: this.$route.query.p,
          sign: this.$route.query.sign,
          policyId: this.$route.query.policyId,
          planCode: value
        }
      });
      this.changeData(type);
      let arrData = this.$lodash.cloneDeep(this.data);
      value && this.$bus.$emit('onRiskInfos', arrData);
    },
    //拼接险种
    flightNumberFun(arr) {
      let strArr = [];
      arr.forEach(e => {
        if (e.amount == 0) {
          strArr.push(e.riskCode);
        }
      });
      return strArr.join(',');
    },
    // 改变试算的数据
    changeData(value, param) {
      if (param == 'YWJHZYJT' && value != -1) {
        this.$bus.$emit('selectCS', 49);
      } else {
        this.$bus.$emit('selectCS', 65);
      }
      this.countData[param] = value;
      this.data = {
        riskInfos: this.riskInfos.filter(item => item.amount != -1), //险种信息
        salPolicy: {
          productCode: this.$route.query.p, //产品code
          bracket: this.countData.BZQJa.toString(), //保费期限
          planCode: this.plan,
          flightnumber: this.flightNumberFun(this.riskInfos) // 另加的拼接险种的字段
        },
        salPolicyExt: {
          isworkheightinvolved: 2,
          occEmpVersion: this.fileCodeContent.id
        },
        salPolicyHolder: {
          addfifty: '1', // 测算类型
          stature: 2 //是否高空（2-否，1-是）
        },
        premiumBaseDtoList: this.occupationNumberList.map(item => {
          if (!item.personNum) {
            item.personNum = 0;
          }
          return item;
        }) //人数
      };
      this.$bus.$emit('onRiskInfos', this.data);
      if (value === 'init') {
        this.countPremiumSum(value);
        return;
      }
      this.countPremiumSum();
    },
    //保费试算
    countPremiumSum(type) {
      this.data.salPolicyHolder.addfifty = '1';
      if (type != 'init') {
        if (!this.totalNumber.allNumber) {
          this.$message.warning('请先选择投保人');
          return;
        }
        if (this.totalNumber.num1_3 && this.totalNumber.allNumber < 3) {
          this.$message.warning('1、2、3类投保人数最少为3人');
          return;
        }
        if (this.totalNumber.num4_6 && this.totalNumber.allNumber < 5) {
          this.$message.warning('4、5、6类投保人数最少为5人');
          return;
        }
        if (this.totalNumber.allNumber > 1000) {
          this.$message.warning('单张保单最高投保人数最多1000人');
          return;
        }
      }
      if (type == 'init') {
        this.data.riskInfos = this.riskInfos;
        this.data.salPolicy.productCode = this.productCode;
        this.data.salPolicy.planCode = this.plan;
        this.data.salPolicy.creator = '1';
        this.data.salPolicy.bracket = '1';
        return;
      }
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.$api.calPremiumEmployer(this.data).then(res => {
            if (res.data.success) {
              let data = res.data.content;
              this.premiumSum = data.totalPremium;
            } else {
              this.$message.error(res.data.returnMsg + '错误');
            }
          });
        }
      });
    }
  },
  beforeDestroy() {
    this.$bus.$off('busRiskInfos');
  }
};
</script>

<style lang="scss" scoped>
.policy {
  display: none;
}

.calTxt_ {
  font-size: 18px !important;
  font-weight: bold !important;
  color: #666666;
}
.pre-box {
  margin-top: 15px;
}
.form_items {
  display: flex;
  width: 100%;
  color: #333;
  margin-bottom: 10px;
}
.risk_ {
  width: 60%;
}
.btn_list {
  margin-top: 20px;
  display: flex;

  .calBtn_ {
    margin-right: 30px;
  }
}
.flex_ {
  display: flex;
  flex-wrap: wrap;
}
.form_item {
  display: flex;
  justify-content: space-between;
  width: 100%;
  color: #333;
  margin-bottom: 10px;

  &.width_50 {
    width: 50%;
  }

  &.width_40 {
    width: 40%;
  }

  &.width_60 {
    width: 60%;
  }

  > label {
    white-space: nowrap;
    margin-right: 10px;
    margin-top: 15px;
  }

  .right_ {
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;

    .select_ {
      margin-top: 10px;
    }

    .check_item {
      display: flex;
      align-items: center;
      margin-right: 10px;
      margin-top: 10px;

      &.on {
        label {
          border-color: #fe8f2d;
        }
      }

      label {
        // border: 1px solid #d9d9d9;
        padding: 3px 10px;
        border-radius: 3px;
        margin-right: 5px;
      }

      &.s_input input {
        width: 50px;
      }

      input {
        width: 150px;
        margin-right: 5px;
      }
    }
  }
}
.p-header {
  width: 100%;
  font-weight: bold;
  font-size: 15px;
  margin-bottom: 0;
}
.waring-color {
  font-size: 12px;
  color: #e6a23c;
}
.gsdiposition {
  width: 300px;
}
.gsdc-icon {
  margin: 3px 3px 0;
}

.zuxianclass {
  margin-bottom: 6px;
  width: 690px;
  display: flex;
  margin-top: 6px;
}
.item-label {
  margin-top: 5px !important;
}
</style>
